const Console = () => console

export default Console
